export default {
  LOAD_PROGRAM_GUIDE_CAREERS (state, payload) {
    state.careers = payload
  },
  LOAD_PROGRAM_CAREER_RESULT (state, payload) {
    state.careerResult = payload
  },
  LOAD_SHOW_ALL_OCCUPATIONS (state, payload) {
    state.showAllOccupations = payload
  },
  LOAD_PROGRAM_ALUMNI_DATA (state, payload) {
    state.programAlumniData = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/programguide/vuex/mutations.js